import React from "react";
import { Card, Row, Col, Image, Table } from "react-bootstrap";
import SeaRoadBrand from '../assets/img/brand/sea-road-dark.png';
import moment from 'moment-timezone';
import { formatCurrency } from "../utils/formatter";

const ApprovedBillingPreview = (props) => {
    const { startDate, endDate, reportList, overallTotalCBM, overallTotalBillableAmount } = props;

    const formattedStartDate = startDate ? moment(startDate).format('YYYY-MM-DD') : '';
    const formattedEndDate = endDate ? moment(endDate).format('YYYY-MM-DD') : '';

    return (
        <Card className="bg-white shadow-sm mb-4" style={{ width: '100%' }}>
            <Card.Body>
                <Row>
                    <Col md="12">
                        <div className="preview-container">
                            <div className="preview-header">
                                <Image src={SeaRoadBrand} className="navbar-brand-light" alt="SEA ROAD TRADING INC." />
                                <div className="company-info">
                                    <h2>SEA ROAD TRADING INC.</h2>
                                    <p>Gochan Compound, Warehouse 5B, MJ Cuenco Avenue, Mabolo, Cebu City, Philippines</p>
                                    <p>Telephone No.: (032) 434-6453 | TIN#: 274-454-701-000</p>
                                </div>
                            </div>
                            <div className="border-line-up"></div>
                            <div className="border-line-down"></div>
                        </div>
                    </Col>
                </Row>
                <div className="preview-body clearfix mb-5">
                    <h1>Approved Billing Report</h1>
                    <div className="left">
                        <p>Start Date: <b>{formattedStartDate}</b></p>
                        <p>End Date: <b>{formattedEndDate}</b></p>
                    </div>
                </div>
                <Table hover className="billing-table-list align-items-center">
                    <thead>
                        <tr>
                        <th className="border-bottom">Display Name</th>
                          <th className="border-bottom">Tracking Number</th>
                          <th className="border-bottom">Loading Date</th>
                          <th className="border-bottom">Sum of CBM</th>
                          <th className="border-bottom">Sum of Sensitive Charge</th>
                          <th className="border-bottom">Sum of Forklift</th>
                          <th className="border-bottom">Sum of Other Charges</th>
                          <th className="border-bottom">Sum of Gross Wt</th>
                          <th className="border-bottom">Rate</th>
                          <th className="border-bottom">Freight Amount</th>
                          <th className="border-bottom">Billable Amount</th>
                          <th className="border-bottom">Sent to customer</th>
                        </tr>
                    </thead>
                    <tbody>
                        {reportList.map((item, index) => (
                            <tr key={index}>
                                <td>
                                    <span className="fw-normal">{item.clientData.displayName || ''}</span>
                                </td>
                                <td>
                                    <span className="fw-normal">{item.containerNumber || ''}</span>
                                </td>
                                <td>
                                    <span className="fw-normal">{moment(item.loadingDate).format('MMM. DD, YYYY') || ''}</span>
                                </td>
                                <td>
                                    <span className="fw-normal">{formatCurrency(parseFloat(item.sumOfCBM)) || 0.00}</span>
                                </td>
                                <td>
                                    <span className="fw-normal">{formatCurrency(parseFloat(item.sumOfSensitiveCharge)) || 0.00}</span>
                                </td>
                                <td>
                                    <span className="fw-normal">{formatCurrency(parseFloat(item.sumOfForklift)) || 0.00}</span>
                                </td>
                                <td>
                                    <span className="fw-normal">{formatCurrency(parseFloat(item.sumOfInland)) || 0.00}</span>
                                </td>
                                <td>
                                    <span className="fw-normal">{formatCurrency(parseFloat(item.sumOfGrossWeight)) || 0.00}</span>
                                </td>
                                <td>
                                    <span className="fw-normal">{formatCurrency(parseFloat(item.rate)) || 0.00}</span>
                                </td>
                                <td>
                                    <span className="fw-normal">{formatCurrency(parseFloat(item.grossAmount)) || 0.00}</span>
                                </td>
                                <td>
                                    <span className="fw-normal">{formatCurrency(parseFloat(item.totalBillableAmount)) || 0.00}</span>
                                </td>
                                <td>
                                    {item.isSentToCustomer && <span className="fw-normal">Yes</span>}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
                <div className="mt-4">
                    <Row>
                        <Col md={6}>
                            <h4><strong>Overall Total CBM:</strong> {parseFloat(overallTotalCBM).toFixed(2)}</h4>
                        </Col>
                        <Col md={6}>
                            <h4><strong>Overall Total Billable Amount:</strong> {formatCurrency(parseFloat(overallTotalBillableAmount)) || 0.00}</h4>
                        </Col>
                    </Row>
                </div>
            </Card.Body>
        </Card>
    );
};

export default ApprovedBillingPreview;
